import React from "react"
import { Stepper, Step, StepLabel, Box } from "@mui/material"
import "./StepperComponent.scss"

interface Props {
  activeStep: number
}
const StepperComponent = ({ activeStep = 0 }: Props) => {
  const steps = ["Step 1", "Step 2"]
  return (
    <Box className="stepper">
      <Stepper activeStep={activeStep} className="stepper__stepper">
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel></StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  )
}
export default StepperComponent
